<style scoped>
.bg-primary {
  background-color: #1a3665 !important;
}
.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.btn-upload {
  border: 2px solid gray;
  color: gray;
  background-color: white;
  padding: 5px 15px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: bold;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 30px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
.collapse-arrow .feather-icon {
  transform: rotate(-180deg);
  transition: 0.3s transform ease-in-out;
  display: inline-block;
}

.collapsed .collapse-arrow .feather-icon {
  transform: rotate(0deg);
}
</style>
<template>
  <div class="card">
    <div
      class="card-header bg-primary font-weight-bold text-white"
      style="display: flex; align-items: center;"
    >
      Petugas Test Center
      <Button
        class="btn btn-md btn-dark px-4 py-2 ml-auto text-white"
        @click="$router.go(-1)"
      >Kembali</Button>
    </div>
    <form  v-on:submit.prevent="postData">
    <div class="card-body">
      <div class="text-center">
        <img
          :src="lihat_foto != '' || lihat_foto != null  ? lihat_foto : `${baseUrl}/files?filename=${formData.foto}&path=users`"
          style="width:120px"
          class="card-img-top img img-responsive rounded-circle elevation-2 border"
          alt="User Picture"
          @error="imgError"
        />
        <div class="mt-2">
          <div class="upload-btn-wrapper">
            <button class="btn-upload">Unggah Gambar</button>
            <input type="file" name="myfile" @change="uploadImage($event)" />
          </div>
        </div>
      </div>
      <div class="card border-0 shadow p-2">        
        <div class="card-body">
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="" class="font-weight-bold">Test Center</label>
                <multiselect
                  label="namaTc"
                  placeholder="Pilih Test Center"
                  id="kotaKab"
                  @select="pilihTc"
                  v-model="multi_master_tc"
                  :options="optionMasterTc"
                ></multiselect>
              </div>
              <div class="form-group col-md-6">
                <label for="name" class="font-weight-bold">Nama Petugas Test Center</label>
                <input
                  type="name"
                  class="form-control"
                  id="name"
                  v-model="formData.name"
                  placeholder="Masukkan nama petugas"
                  required
                />
              </div>
             
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="email" class="font-weight-bold">Email Petugas</label>
                <input v-model="formData.email" type="email" class="form-control" id="email" placeholder="Masukkan email petugas" />
              </div>
              <div class="form-group col-md-6">
                <label for="no_telp" class="font-weight-bold">Nomor Telepon</label>
                <input
                  type="number"
                  class="form-control"
                  id="no_telp"
                  v-model="formData.noTelephone"
                  placeholder="Masukkan nomor telepon petugas"
                />
              </div>
             
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="usename" class="font-weight-bold">Username</label>
                <input v-model="formData.username" type="text" class="form-control" id="usename" placeholder="Username Petugas" />
              </div>
              <div class="form-group col-md-6">
                <label for="pass" class="font-weight-bold">Password</label>
                <input v-model="formData.password" type="password" class="form-control" id="pass" />
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="usename" class="font-weight-bold">Alamat</label>
                <textarea v-model="formData.alamat" name="" id="" cols="20" rows="10" class="form-control"></textarea>
              </div>
            </div>
            <div class="form-row">
              <CCol sm="12">
                <label for class="font-weight-bold">Status</label>
                <br />
                <div class="d-flex align-items-center">
                  <div class="custom-control custom-radio custom-control-inline">
                    <input 
                     type="radio" 
                     class="custom-control-input" 
                     name="customRadio" 
                     id="aktif" 
                     value="1"
                     required
                     v-model="formData.status"
                    />
                    <label class="custom-control-label" for="aktif">Aktif</label>
                  </div>
                  <div class="custom-control custom-radio custom-control-inline">
                    <input 
                     type="radio" 
                     class="custom-control-input" 
                     name="customRadio"
                     required 
                     id="tidak_aktif" 
                     value="0"
                     v-model="formData.status"
                    />
                    <label class="custom-control-label" for="tidak_aktif">Tidak Aktif</label>
                  </div>
                </div>
              </CCol>
            </div>
        </div>
      </div>
    
      
    </div>
    <div class="card-footer bg-white border-0 ml-auto mb-5 mr-3">
     
        <Button class="btn btn-md btn-success px-4 py-2" style="float:right" type="submit" color="success">Simpan</Button>
    
    </div>
    </form> 
  </div>
</template>
<script>

import {MasterTC} from '../../../mixins/master/MasterTC'
import {UploadImage} from '../../../mixins/UploadImage'
import {AlertUtils} from '../../../mixins/AlertUtils'
import baseUrl from '../../../services/base-url'
import PetugasTcService from "../../../services/user-manajemen/petugas-tc.service";

export default {
  mixins : [MasterTC,UploadImage,AlertUtils],
  data: function() {
    return {
      nama_kota_kab : '',
      lihat_foto : null,
      formData: {
        name: "",
        username: "",
        email: "",
        noTelephone: "",
        password: "",
        idTc : "",
        alamat : "",
        status: "",
        foto : null,
      },
    }
  },
  mounted() {
    this.getAllTestCenter();
    this.getData(this.$route.params.id_user)
  },
  methods: {
    imgError(e) {
      e.target.src = '/img/avatars/2.jpeg'
    },
    getData(id) {
      PetugasTcService.getPetugasTcById(id)
      .then(response => {
        // comment console console.log(response);
        var varData = response.data.singleData;
        this.lihat_foto = baseUrl()+'/files?filename='+varData.foto+'&path=users'
        this.formData.name = varData.name;
        this.formData.email = varData.email;
        this.formData.status = varData.status;
        this.formData.username = varData.username;
        this.formData.alamat = varData.alamat
        this.formData.foto = varData.foto
        this.formData.idTc = varData.id_tc;
        this.nama_kota_kab = varData.nama_kota_kab;
        this.formData.noTelephone = varData.no_telp
        this.multi_master_tc = [
          {
            namaTc : varData.nama_tc
          }
        ]
      }).catch(error => {
        // comment console console.log(error)
      })
    },
    postData() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      var formData = this.formData;
      if (typeof formData.foto === "string") {
        delete formData.foto
      }
      if (formData.foto === null) {
        delete formData.foto
      }
      var vm = this;
      PetugasTcService.putPetugasTc(this.$route.params.id_user,formData)
      .then(response => {
        // comment console console.log(response);
        loader.hide();
        vm.alertSuccess();
        this.$router.push({ path: "/user-manajemen/petugas-tc-aktif" });
      }).catch(error => {
        // comment console console.log(error);
        loader.hide();
        this.alertError(error.response.data.message);
      })
    },
    pilihTc(value) {
      this.formData.idTc = value.idTc;
    }
  }
 
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>